module.exports = __webpack_public_path__ + "img/password.8797330c.svg";